import { ProjectMemberRole, TaskMemberRole } from '@graphql/generated';

export interface SubscriptionDetails {
  isSubscriptionActive?: boolean;
  isSubscriptionCanceled?: boolean;
  isSubscriptionOnTrial?: boolean;
  subscriptionStatus?: string;
  trialEndsAt?: string | null;
  currentPeriodEnd?: string | null;
  expirationDate?: string | null;
}

export const isSubscriptionAccessible = (
  details?: SubscriptionDetails,
  storageRemaining?: number | string,
  isPersonal?: boolean,
  currentUserRole?: string,
  currentUserTaskRole?: string
): boolean => {
  if (isPersonal) return true;

  if (!details || details === null) {
    if (currentUserRole && !currentUserTaskRole) {
      return currentUserRole !== ProjectMemberRole?.Viewer;
    }
    if (currentUserTaskRole) {
      if (
        (currentUserRole && currentUserRole === ProjectMemberRole.Owner) ||
        currentUserRole === ProjectMemberRole.Admin
      ) {
        return true;
      }
      return currentUserTaskRole !== TaskMemberRole?.Viewer;
    }
    return false;
  }

  // I comment here according to Kang -> Group Chat: 12/17/25 09:06Am Web: My Tasks Revamp & Invitation
  // When team is expired you just can't add members, create new projects.
  // const now = new Date();
  // const {
  //   subscriptionStatus,
  //   trialEndsAt,
  //   isSubscriptionActive,
  //   isSubscriptionOnTrial,
  //   expirationDate,
  // } = details;

  // const hasValidSubscription =
  //   (subscriptionStatus === 'active' &&
  //     expirationDate &&
  //     new Date(expirationDate) > now) ||
  //   (subscriptionStatus === 'trialing' &&
  //     isSubscriptionOnTrial &&
  //     trialEndsAt &&
  //     new Date(trialEndsAt) > now) ||
  //   isSubscriptionActive;
  //
  // if (!hasValidSubscription) return false;

  if (storageRemaining !== undefined) {
    const storage = Number(storageRemaining);
    if (isNaN(storage) || storage <= 0) {
      return false;
    }
  }

  return true;
};
